import React, { useMemo } from 'react'
import { TileImage } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import Image from 'components/LegacyImage'
import { TimelineProps } from './TimelineSection'
import style from './Timeline.module.scss'

const CAMP_MODULES_LIMIT = 8

export const Timeline = ({ featuredSession: session }: TimelineProps) => {
  const { t } = useTranslation('@mc/next')

  // remove the last module and limit shown to CAMP_MODULES_LIMIT amount
  const displayModules = useMemo(
    () => session.modules?.slice(0, -1).slice(0, CAMP_MODULES_LIMIT),
    [session.modules],
  )

  return (
    <div className={style.progressBarContainer} data-ba='hub-timeline'>
      <div className={style.progressBar}>
        {displayModules.map((module, index) => (
          <div className={style.progressBarNode} key={module.id}>
            <div className={`mc-shadow--high ${style.uplevelTile}`}>
              <div className={style.uplevelTileImage}>
                <TileImage
                  image={
                    <Image src={module.marketing3x2} layout='fill' alt='' />
                  }
                />
              </div>
              <div className='mc-p-3 mc-text--bold'>
                <p className='mc-text-color--gray-500'>
                  {t('sessions.timelineSection.section', { number: index + 1 })}
                </p>
                <p className={style.timelineItemDescription}>{module.name}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
